"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.build = void 0;
const react_1 = __importDefault(require("react"));
const ChatListItem_1 = __importDefault(require("./ChatListItem"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const stateFunctions = __importStar(require("../../domain/stateFunctions"));
const messages_1 = require("../../domain/model/messages");
const messageFunctions_1 = require("../../domain/messageFunctions");
const CyclesContent_1 = require("../mainPanel/CyclesContent");
function build(chat, userDictionary, index, selectedChatIndex, me) {
    var _a, _b;
    let name;
    let key;
    let isGroup;
    let userId = null;
    let userImageId = null;
    let themTyping = false;
    let userOnline = false;
    let participantsTyping = [];
    if (chatFunctions.isDirectChat(chat)) {
        const user = userDictionary.hasOwnProperty(chat.them) ? userDictionary[chat.them] : null;
        name = (_a = user === null || user === void 0 ? void 0 : user.username) !== null && _a !== void 0 ? _a : "";
        key = "D-" + chat.them.toString();
        isGroup = false;
        themTyping = chatFunctions.isConfirmedChat(chat) && chat.themTyping;
        userOnline = (userDictionary.hasOwnProperty(chat.them) ? userDictionary[chat.them].minutesSinceLastOnline < 2 : false);
        userId = chat.them;
        userImageId = (_b = user === null || user === void 0 ? void 0 : user.imageId) !== null && _b !== void 0 ? _b : null;
    }
    else {
        name = chat.subject;
        isGroup = true;
        if (chatFunctions.isConfirmedChat(chat)) {
            key = "G-" + chat.chatId.toString();
            participantsTyping = stateFunctions.getUsers(chat.participantsTyping, userDictionary).map(u => u.username);
        }
        else {
            key = "NG-" + chat.subject;
        }
    }
    let latestMessageText = "";
    for (let i = chat.messages.length - 1; i >= 0; i--) {
        const message = chat.messages[i];
        if ("content" in message) {
            if (message.content.kind === "cycles") {
                latestMessageText = CyclesContent_1.formatCyclesText(message.content.amount, messages_1.sentByMe(message, me), name);
            }
            else {
                latestMessageText = messageFunctions_1.getContentAsText(message.content);
            }
            break;
        }
    }
    return (react_1.default.createElement(ChatListItem_1.default, { key: key, name: name, date: "displayDate" in chat ? chat.displayDate : undefined, index: index, selected: index === selectedChatIndex, latestMessage: latestMessageText, isGroup: isGroup, userId: userId, userImageId: userImageId, unreadCount: chatFunctions.getUnreadMessageCount(chat), themTyping: themTyping, userOnline: userOnline, participantsTyping: participantsTyping }));
}
exports.build = build;
